import React from 'react';
import { useParams } from 'react-router';
import styled from 'styled-components';
import { ProjectId } from 'api/models';
import { Project } from 'api/project';
import { Loading } from 'components/atoms/loading';
import { CurrentSpaceContext } from 'components/organisms/spaces/context';
import { RenderRocketlaneDocument } from 'components/organisms/spaces/space-tab/space-tab';
import { useSpaceActions } from 'components/pages/project-details/project-spaces/use-space-actions';
import { useProjectDetail } from 'data/projects';
import { useSpaceTab } from 'data/space-tabs/hooks';

const StyledDiv = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const RespSpaceTab: React.FC<{
  project: Project;
  projectId: string;
  spaceTabId: string;
  spaceId: string;
}> = ({ project, projectId: _, spaceId, spaceTabId }) => {
  const { currentSpaceDetails } = useSpaceActions({
    spaceId,
    project,
    spaceTabId,
  });
  const { data } = useSpaceTab(Number(spaceTabId));

  return currentSpaceDetails === undefined || data === undefined ? (
    <StyledDiv>
      <Loading />
    </StyledDiv>
  ) : (
    <CurrentSpaceContext.Provider value={currentSpaceDetails}>
      <RenderRocketlaneDocument data={data} />
    </CurrentSpaceContext.Provider>
  );
};

export const RespSpaceTabPage: React.FC = () => {
  const { projectId, spaceId, spaceTabId } =
    useParams<{ projectId: string; spaceTabId: string; spaceId: string }>();
  const { data: project } = useProjectDetail(ProjectId(Number(projectId)));

  return project === undefined ? (
    <StyledDiv>
      <Loading />
    </StyledDiv>
  ) : (
    <RespSpaceTab
      project={project}
      projectId={projectId}
      spaceId={spaceId}
      spaceTabId={spaceTabId}
    />
  );
};
